export function generateSlug(itemName) {
    const slug = itemName?.replace(/[^a-zA-Z0-9-]/g, '');
    return slug || '-';
}
